import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.49 4.66H8.35v-.55a2.05 2.05 0 0 0-2-2.05H3.71a2.05 2.05 0 0 0-2 2.05v7.78a2.05 2.05 0 0 0 2.05 2h5.1a.75.75 0 0 0 0-1.5h-.51V6.16h3.14a.55.55 0 0 1 .51.54v.6a.75.75 0 0 0 1.5 0v-.6a2.05 2.05 0 0 0-2.01-2.04Zm-4.64 7.78H3.71a.55.55 0 0 1-.55-.55V4.11a.55.55 0 0 1 .55-.55H6.3a.55.55 0 0 1 .55.55Zm4-3.84h-1.3V7.3h1.3Zm-5.19 2.69h-1.3V10h1.3Zm0-2.69h-1.3V7.3h1.3Zm0-2.68h-1.3v-1.3h1.3Zm9.77 5.77a.76.76 0 0 1-.75.75h-1.14v1.14a.75.75 0 0 1-1.5 0v-1.14H10.9a.75.75 0 0 1 0-1.5H12V9.79a.75.75 0 0 1 1.5 0v1.15h1.14a.75.75 0 0 1 .79.75Z';
const draw24px =
  'M17,7.25H11.73V6A2.75,2.75,0,0,0,9,3.25H5A2.75,2.75,0,0,0,2.23,6V18A2.75,2.75,0,0,0,5,20.75h9.46a.75.75,0,0,0,0-1.5H11.73V8.75H17A1.25,1.25,0,0,1,18.23,10v1.93a.75.75,0,0,0,1.5,0V10A2.75,2.75,0,0,0,17,7.25Zm-6.75,12H5A1.25,1.25,0,0,1,3.73,18V6A1.25,1.25,0,0,1,5,4.75H9A1.25,1.25,0,0,1,10.23,6ZM16,12.92H14v-2h2Zm0,2.16v1H15v1H14v-2Zm-8,2H6v-2H8Zm0-4.16H6v-2H8ZM8,8.79H6v-2H8Zm14.37,9.1a.75.75,0,0,1-.75.75H19.67v1.93a.75.75,0,0,1-1.5,0V18.64H16.25a.75.75,0,0,1,0-1.5h1.92V15.22a.75.75,0,1,1,1.5,0v1.92H21.6A.76.76,0,0,1,22.35,17.89Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const BuildingsPlusIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'buildingsPlus')) as IconWithRender;

BuildingsPlusIcon.displayName = 'BuildingsPlusIcon';
BuildingsPlusIcon.propTypes = Icon.propTypes;
BuildingsPlusIcon.renderIcon = (props) => <BuildingsPlusIcon {...props} />;
export default BuildingsPlusIcon;
